// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSwitchUserOutlinedSvg from "@fishx/icons-svg/es/asn/PSwitchUserOutlined";
import FishxIcon from '../components/FishxIcon';

var PSwitchUserOutlined = function PSwitchUserOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSwitchUserOutlinedSvg
  }));
};

PSwitchUserOutlined.displayName = 'PSwitchUserOutlined';
export default React.forwardRef(PSwitchUserOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSwitchUserOutlined.js
// module id = 3674
// module chunks = 0